import { useUserAuthStore, isUserTypeAllowed } from '../store';
import { createAuthHook, type AuthHookResult } from '@/shared/lib/auth-hook-factory';
import type { AuthUser } from '@/shared/lib/auth-store-factory';

const useUserAuthBase = createAuthHook({
  store: () => useUserAuthStore.getState(),
  storageKey: 'examfy-user-auth-storage',
  logPrefix: 'Auth',
  validateUser: (user: AuthUser) => isUserTypeAllowed(user.type),
  mapUserData: (userData: Record<string, unknown>) => ({
    name: userData.name as string,
    email: userData.email as string,
    id: (userData.id as string) || (userData.identification_id as string),
    tenant_id: (userData.tenant_id as string) || (userData.tenantId as string),
    document_unique_number: userData.identification_id as string,
    associated_owner_id:
      (userData.associated_owner_id as string) ||
      (userData.associatedOwnerID as string) ||
      (userData.associatedOwnerId as string),
    type: userData.type as string,
    onboarding_status: userData.onboarding_status as string,
  }),
});

const useUserAuth = (): AuthHookResult => {
  return useUserAuthBase();
};

export { useUserAuth };
export type { AuthUser as User };
